import React from "react";
import { cn } from "@/lib/utils";

export function Disclaimer({ className }) {
  return (
    <p
      className={cn("px-1 text-[11px] leading-relaxed text-zinc-400", className)}
      data-testid="financial-disclaimer"
    >
      Hasil merupakan estimasi berdasarkan data yang Anda masukkan dan bukan
      nasihat keuangan profesional. Kondisi sebenarnya dapat berbeda.
    </p>
  );
}
